import { render, staticRenderFns } from "./AwlPagination.vue?vue&type=template&id=33680de4&"
import script from "./AwlPagination.vue?vue&type=script&lang=js&"
export * from "./AwlPagination.vue?vue&type=script&lang=js&"
import style0 from "./AwlPagination.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports